<template lang="pug">
  b-container
    tutorial-modal(view="Ventas")
      template(v-slot:default)
        b-container
          p En esta sección puedes ver las órdenes o ventas que se han realizado en el Chatbot y cada una tiene un estatus:
          p
            b Órdenes activas
          ul 
            li(v-for="order in order_status", v-if="order.meta.isActive")
              b.mr-1 {{ order.title }}:
              span {{ order.description }}
          p
            b Órdenes inactivas
          ul 
            li(v-for="order in order_status", v-if="!order.meta.isActive") 
              b.mr-1 {{ order.title }}:
              span {{ order.description }}
          p Para abrir una orden solo debes dar click sobre ésta y se abrirá una vista lateral que muestra detalles de la órden:
          ul 
            li Estatus
            li Dirección de envío o punto de recolección
            li Productos en la orden y total
            li Datos de contacto del cliente
          b-img.mb-3(src="@/assets/tutorial/orders.png", fluid, rounded, center)
          p También puedes actualizar el estatus de las ordenes y se le enviará una notificación a tu cliente sobre el estatus de su pedido:
          b-img(src="@/assets/tutorial/update-order.png", fluid, rounded, center, width="400")
    b-form-row.align-items-center.justify-content-between.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Órdenes
      b-col.mb-2.mb-md-0(md="auto")
        b-dropdown.mr-2(variant="light", right, :no-caret="Boolean(filtersCount)", :menu-class="['filters-dropdown']")
          template(slot="button-content")
            filter-icon.icon-md
            span.ml-1 Plataformas
            b-badge.ml-1(variant="primary", v-if="filtersCount") {{ filtersCount  }}
          //b-dropdown-header Estado de orden  {{ selected_statuses.length ? `(${selected_statuses.length})` : '' }}
          //b-dropdown-form
            b-form-group
              b-form-checkbox-group(v-model="selected_statuses", stacked, :options="order_statuses")
          b-dropdown-header Plataformas
          b-dropdown-form
            b-form-group
              b-form-radio-group(name="platforms", stacked, :options="parsedPlatforms", v-model="selected_platform")
      b-col(md="auto")
        b-button(variant="primary", @click="getOrders(true)", :disabled="loading")
          .d-flex.align-items-center
            rotate-ccw-icon.icon-md.mr-2
            span Actualizar órdenes ({{count_down}})
    b-tabs.mb-3(v-model="selectedTab")
      b-tab(title="Órdenes activas")
      b-tab(title="Todas las órdenes")

    b-form-group
      b-input-group
        template(#append)
          b-input-group-text
            search-icon.icon-md
        b-form-input(placeholder="Buscar orden..." v-model="search")
    
    b-card(no-body)
      template(slot="header")
        b-row.align-items-center
          b-col.my-1
            b-form-checkbox.text-secondary(:indeterminate="indeterminate", :checked="allChecked", @change="selectAll($event)") Seleccionar todo
          b-col(cols="auto")
            b-dropdown.mr-2(variant="light", size="md", right, :no-caret="Boolean(selected_statuses.length)", :menu-class="['filters-dropdown']")
              template(slot="button-content")
                filter-icon.icon-sm
                span.ml-1 Filtros
                b-badge.ml-1(variant="primary", v-if="selected_statuses.length") {{ selected_statuses.length  }}
              b-dropdown-header Estado de orden  {{ selected_statuses.length ? `(${selected_statuses.length})` : '' }}
              b-dropdown-form
                b-form-group
                  b-form-checkbox-group(v-model="selected_statuses", stacked, :options="order_statuses")
      b-table.card-table.mb-0(:items="parsed_orders", :fields="fields", responsive, hover, @row-clicked="openOrderModal($event)", show-empty)
        template(v-slot:empty)
          p.mb-0.text-secondary No hay órdenes disponibles
        template(v-slot:cell(order_id)="{ item, value }")
          .d-flex.align-items-center
            b-form-checkbox(v-model="selected_orders", name="order", :value="value")
            span {{ value }}
        template(v-slot:cell(user_id)="{ item }")
          p.mb-0 {{ item.user_first_name }} {{ item.client_last_name }}
          .text-secondary {{item.email}}
        template(v-slot:cell(delivery_address)="{ item }")
          .text-sm {{item.delivery_address || '-'}}
          .text-sm.text-secondary Ref: {{item.reference}}
        template(v-slot:cell(total_final)="{ item }")
          p.mb-0 ${{ item.total_final }}
        template(v-slot:cell(pickup_location_id)="{ item }")
          div(v-if="item.Pickup_Location") {{ item.Pickup_Location.name }}
          div(v-else) -
        template(v-slot:cell(platform)="{ item }")
          .d-flex.align-items-center(:style="{color: platformColor(item.platform)}")
            v-icon.mr-1(:name="platformIconName(item.platform)")
            span {{ item.platform }}
        template(v-slot:cell(updatedAt)="{ item }")
          p.mb-0 {{ $moment(item.updatedAt).format('DD MMM YYYY, HH:mm') }}
    .d-flex.align-items-center
      b-pagination.mb-0.mr-2(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getOrders')", v-if="v_paginationShow")
      b-spinner(small, v-if="loading", variant="primary")
    SideModal(padding="20px", v-model="order_modal", :loading="loading_order", @close="clearOrderModal($event)")
      template
        h4.d-inline-block
          b-badge(:variant="'soft-' + getOrderStatusBadge(order.status).color") {{ getOrderStatusBadge(order.status).title }}
        p.text-secondary.mb-4 {{ getOrderStatusBadge(order.status).description }}
        .mb-4
          h5.mb-1 Id Orden: {{ order.order_id }}
          .text-secondary Ref: {{ order.reference }}
          .text-help Actualizada {{ $moment(order.updatedAt).format('DD MMM YYYY - hh:mm A') }}
        .mb-4
          .text-secondary.text-uppercase.mb-1.text-sm.font-weight-bold Datos de cliente
          div.font-weight-bold(v-if="order.User") {{ order.User.first_name }} {{order.User.last_name}}
          div(v-if="order.email") {{ order.email }}
            b-link.ml-2(:href="'mailto:' + order.email")
              mail-icon.icon-sm.mb-1
          p.mb-0(v-if="order.cell_phone") {{ order.cell_phone }}
            b-link.ml-2.text-success(v-if="order.platform.includes('whatsapp')", :href="'https://wa.me/52' + order.cell_phone", target="_blank" )
              v-icon.icon-sm.mb-1(name="brands/whatsapp" )
            b-link.ml-2(@click="copy(order.cell_phone)")
              copy-icon.icon-sm.mb-1
          div(:style="{color: platformColor(order.platform)}")
            v-icon.mr-1(:name="platformIconName(order.platform)")
            span {{ order.platform }}
        
        b-alert.mb-4(variant="warning", show, v-if="!order.pickup_location_id && !order.delivery_address && isEcommerce")
          alert-triangle-icon.mr-2.icon-md
          span No se ha especificado punto de recolección o dirección de envío
        .mb-4(v-else-if="order.delivery_address")
          .text-secondary.text-uppercase.mb-1.text-sm.font-weight-bold Dirección de envío
          p.mb-1
            map-pin-icon.icon-md.text-primary.mr-1
            span {{ order.delivery_address }}
        .mb-4(v-else-if="pickup_location.pickup_location_id")
          .text-secondary.text-uppercase.mb-3.text-sm.font-weight-bold Punto de entrega seleccionado
          p.mb-1 {{ pickup_location.name }}
          p.mb-0.text-sm {{ pickup_location.description }}
          p.mb-2.text-secondary.text-sm {{ pickup_location.disponibility_description }}
          b-img.mb-2(:src="mapsURLBig + '&markers=color:0x1d91fe|label:L|' + pickup_location.latitude + ',' + pickup_location.longitude", v-if="!map_image_error", @error="map_image_error = true", rounded, fluid)
          p.text-help.text-sm {{ pickup_location.full_address }}
        div.mb-4(v-if="order.extra_message")
          b-card.bg-light.mb-0
            p.text-secondary.text-sm.text-uppercase Inidicaciones adicionales
            p.mb-0 {{ order.extra_message }}
        b-list-group.list-group-flush.mb-3
          b-list-group-item(v-if="order_summary.length")
            .text-secondary.text-uppercase.mb-2.text-sm.font-weight-bold Productos de la orden
            b-form-row.product-row.border-bottom(v-for="(item, index) in order_summary" :key="index")
              b-col(cols="auto")
                b-img(width="60" height="60" rounded :src="item.image" :blank="!item.image" blank-color="#f2f2f2" style="object-fit:cover;")
              b-col
                b-form-row
                  b-col
                    p.font-weight-bold.mb-0 {{ item.product }}
                  b-col(cols="auto")
                    p.font-weight-bold.mb-0 {{ item.price }}
                  b-col(cols="12")
                    ul(v-if="item.variants && item.variants.length")
                      li.text-secondary(v-for="item_v in item.variants" :key="item_v") {{item_v}}
                    .d-flex.align-items-center.justify-content-between
                      p.mb-0.text-secondary {{ item.quantity }} unidades
                      //b-link.text-danger.text-sm(@click="removeProduct(item)") Quitar

          b-list-group-item(v-if="order.packagesSummary.length")
            .text-secondary.text-uppercase.mb-2.text-sm.font-weight-bold Paquetes de la orden
            .package-row.mb-4(v-for="(productPackage, index) in order.packagesSummary" :key="index")
              b-form-row.border-bottom.mb-1
                b-col.font-weight-bold {{productPackage.name}}
                b-col.text-secondary(cols="auto")
                  span(:class="{ 'scratch': productPackage.newPrice }") {{productPackage.price}}
                  span.ml-2(v-if="productPackage.newPrice") {{productPackage.newPrice}}
                  span.ml-1 x {{productPackage.count}}
              b-form-row.package-option.mb-1.align-items-center(v-for="(option, optionIndex) in productPackage.options", :key="optionIndex")
                b-col(cols="auto")
                  b-img(width="50px" height="50px" rounded :src="option.image" :blank="!option.image" blank-color="#f2f2f2" style="object-fit:cover;")
                b-col
                  b-form-row.text-sm
                    b-col.font-weight-bold {{option.name}}
                    b-col.text-secondary(cols="auto")
                      span.mr-1(v-if="option.extra_price") {{option.extra_price}}
                      span x {{option.count}}
              b-form-row.price-total.justify-content-end
                b-col.border-top.border-cool.d-flex(cols="auto") {{productPackage.total}}

          b-list-group-item(v-if="order_summary.length || order.packagesSummary.length")
            b-form-row.mb-2
              b-col
                span Subtotal:
              b-col(cols="auto")
                span {{ order.total || 0 }}

            b-form-row.mb-2
              b-col
                span Envío:
              b-col(cols="auto")
                span {{ order.delivery_price || 0 }}

            b-form-row.mb-2
              b-col
                span Descuento:
              b-col(cols="auto")
                span {{ order.discount || 0 }} %

            b-form-row.font-weight-bold
              b-col
                span Total:
              b-col(cols="auto")
                span {{ order.total_final || 0 }}
          b-list-group-item(v-else)
            div.text-center.text-secondary No hay elementos en la orden
        .mb-3(v-if="order.status != 'canceled' && order.status != 'delivered' && order.status != 'refunded'")
          .mb-3.text-center(v-if="$can('read', 'refund_payments') && $moment().isSame($moment(order.updatedAt), 'day')")
            b-link.text-danger(@click="cancelOrder") Solicitar cancelación
          b-dropdown.d-flex.mb-3(variant="soft-secondary", no-caret, right, size="lg", :disabled="loading_order", :menu-class="['order-status-dropdown']")
            template(slot="button-content")
              .d-flex.align-items-center.justify-content-between
                span.mr-2 Actualizar estatus
                b-spinner(small, variant="primary", v-if="loading_order")
                chevron-down-icon(v-else)
            template(v-if="order.status == 'in_process' || order.status == 'process'")
              b-dropdown-item(@click="confirmPaymentAgaintsDelivery()")
                p.mb-0.text-wrap {{ order_status.find(s => s.name == 'pay_on_delivery').title }}
                p.mb-0.text-sm.text-secondary.text-wrap {{ order_status.find(s => s.name == 'pay_on_delivery').description }}
              b-dropdown-divider
            b-dropdown-item(v-for="(status, index) in order_status", :key="index", v-if="status.name != 'delivered' && (!status.meta || !status.meta.hidden)", @click="updateOrder(status)")
              p.mb-0.text-wrap {{ status.title }}
              p.mb-0.text-sm.text-secondary.text-wrap {{ status.description }}
            b-dropdown-divider
            b-dropdown-item(@click="updateOrder(order_status.find(s => s.name == 'delivered'))")
              p.mb-0.text-wrap {{ order_status.find(s => s.name == 'delivered').title }}
              p.mb-0.text-sm.text-secondary.text-wrap {{ order_status.find(s => s.name == 'delivered').description }}
          b-form-checkbox(v-model="notify_checkbox") Notificar al usuario en un mensaje cuando cambie el estado de su orden
        p.text-help.text-center(v-else) No puedes modificar esta orden
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const accountController = createNamespacedHelpers('account')
const orderController = createNamespacedHelpers('order')
const platformController = createNamespacedHelpers('platform')

import TutorialModal from '@/components/TutorialModal.vue'

import platformTranslator from '@/helpers/platformTranslator'
import orderStatus from '@/data/orderStatus'

export default {
  name: 'Orders',
  components: {
    TutorialModal
  },
  mixins: [platformTranslator],
  data () {
    return {
      selected_orders: [],
      order_modal: false,
      loading_order: false,
      order_status: orderStatus,
      map_image_error: false,
      shouldRefresh: true,
      order: {
        reference: '',
        order_id: '',
        Items: [],
        Item_Variants: [],
        packagesSummary: []
      },
      order_summary: [],
      fields: [
        {
          key: 'order_id',
          label: 'Id Orden'
        },
        {
          key: 'user_id',
          label: 'Cliente'
        },
        {
          key: 'delivery_address',
          label: 'Dirección / Referencia'
        },
        {
          key: 'platform',
          label: 'Plataforma'
        },
        {
          key: 'cell_phone',
          label: 'Teléfono'
        },
        {
          key: 'pickup_location_id',
          label: 'Sucursal'
        },
        {
          key: 'total_final',
          label: 'Total'
        },
        {
          key: 'updatedAt',
          label: 'Última actualización'
        }
      ],
      mapsURLBig: 'https://maps.googleapis.com/maps/api/staticmap?&size=340x150&maptype=roadmap&region=mx&language=es&key=AIzaSyBYuA0X15QfSmoVwQOL_UxpGRNEV5BYeCo',
      pickup_location: {},
      loading: false,
      selected_platform: {
        title: 'Todas',
        platform_id: '',
        name: 'all'
      },
      selected_statuses: [],
      order_statuses: [
        {
          text: 'Pagadas',
          value: 'paid'
        },
        {
          text: 'Pago contra entrega',
          value: 'pay_on_delivery'
        },
        {
          text: 'Enviadas',
          value: 'sent'
        },
        {
          text: 'En preparación',
          value: 'preparing'
        },
        {
          text: 'Completada',
          value: 'delivered'
        },
        {
          text: 'Pendientes',
          value: 'process'
        },
        {
          text: 'En proceso',
          value: 'in_process'
        },
        {
          text: 'Canceladas',
          value: 'canceled'
        },
        {
          text: 'Reembolsadas',
          value: 'refunded'
        },
      ],
      order_active_statuses: [
        {
          text: 'Pagadas',
          value: 'paid'
        },
        {
          text: 'Pago contra entrega',
          value: 'pay_on_delivery'
        },
        {
          text: 'Enviadas',
          value: 'sent'
        },
        {
          text: 'En preparación',
          value: 'preparing'
        },
      ],
      notify_checkbox: true,
      time_out: null,
      refresh_timer: null,
      count_down: 9,
      calendarFormats: {
        sameDay: '[Hoy], hh:mm A',
        nextDay: '[Mañana], hh:mm A',
        nextWeek: 'dddd, hh:mm A',
        lastDay: '[Ayer], hh:mm A',
        lastWeek: 'dddd, hh:mm A',
        sameElse: 'DD MMMM YYYY, HH:mm'
      },
      selectedTab: 0,
      search: '',
      searchTimeout: null
    }
  },
  computed: {
    ...orderController.mapState({
      orders: state => state.orders
    }),
    ...platformController.mapState({
      platforms: state => state.platforms
    }),
    ...accountController.mapState({
      account: state => state.account,
    }),
    isEcommerce () {
      return this.account.type == 'konverza-ecommerce'
    },
    indeterminate () {
      let selectedL = this.selected_orders.length
      let ordersL = this.parsed_orders.length

      if (selectedL && ordersL) {
        if (ordersL > selectedL) return true
        return false
      }

      return false
    },
    allChecked () {
      let selectedL = this.selected_orders.length
      let ordersL = this.parsed_orders.length

      if (selectedL && ordersL) {
        if (ordersL == selectedL) return true
        return false
      }

      return false
    },
    parsedPlatforms () {
      let arr = this.platforms.map(p => {
        return {
          text: p.title,
          value: {
            title: p.title,
            platform_id: p.platform_id,
            name: p.name
          }
        }
      })

      arr.splice(0, 0, {
        text: 'Todas',
        value: {
          title: 'Todas',
          platform_id: '',
          name: 'all'
        }
      })

      return arr
    },
    filtersCount () {
      let count = 0
      if (this.selected_platform.name && this.selected_platform.name != 'all') {
        count ++
      }
      return count
    },
    parsed_orders () {
      /*let _orders = this.orders.filter(o => { return (o.status != 'paid' && o.status != 'sent' && o.status != 'preparing') })
      return this.selected_statuses.length ? _orders.filter(o => { return this.selected_statuses.includes(o.status) }) : _orders*/
      
      this.orders = this.orders.map(order => {
        if(order.platform === "whatsapp_official") order.platform = "WhatsApp"
        return order
      })
      return this.selected_statuses.length ? this.orders.filter(o => { return this.selected_statuses.includes(o.status) }) : this.orders
    },
  },
  methods: {
    ...mapActions(['order/all', 'order/get', 'order/update', 'order/cancel', 'location/get', 'platform/all']),
    getPlatforms () {
      let self = this

      this['platform/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getOrders (refresh, auto_refresh) {
      let self = this
      this.loading = true

      let pagination = refresh ? {page: this.paginationCurrentPage, limit: this.v_paginationLimit} : this.paginationParamsObject
      if(refresh){
        clearTimeout(this.time_out)
      }
      clearInterval(this.refresh_timer)

      //lleva pagiación
      this['order/all']({
        account_id: self.$route.params.account_id,
        params: {
          ...pagination,
          platform: self.selected_platform.name,
          status: this.search.length ? null : (self.selectedTab == 0 ? self.order_active_statuses.map(s => s.value).join(',') : null),
          reference: this.search || null
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (!refresh)
              self.parsePaginationDataFromResponse(res)
            else if(!auto_refresh)
              self.$message.info('Órdenes actualizadas')

            /*if (this.shouldRefresh) {
              self.time_out = setTimeout(() => {
                self.getOrders(true, true)
              }, 10000)
              self.startTimer()
            }*/
          }
        }
      })
    },
    getOrder (order_id) {
      let self = this
      this.loading_order = true

      this['order/get']({
        order_id: order_id,
        account_id: self.$route.params.account_id,
        callback: res => {
          self.loading_order = false
          if (res.error) {
            self.$message.error(res.error)
            self.order_modal = false
          } else {
            self.order = Object.assign(self.order, res.resource)
            self.order_summary = self.order.summary.slice()
            let formater = new Intl.NumberFormat("es-MX", {style: "currency", currency: self.order.currency || "MXN"});
            self.order.total = formater.format(self.order.total)
            self.order.delivery_price = formater.format(self.order.delivery_price)
            self.order.total_final = formater.format(self.order.total_final)

            if (self.order.pickup_location_id) {
              self.getLocation(self.order.pickup_location_id)
            }
            this.order_modal = true
          }
        }
      })
    },
    updateOrder (status, notify = true) {
      var self = this

      let json_data = {
        status: status.name,
        notify: self.notify_checkbox,
        order_id: self.order.order_id,
        account_id: self.$route.params.account_id,
      };

      this['order/update']({
        ...json_data,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Orden actualizada')
            self.getOrder(self.order.order_id)

            self.$store.commit('order/updateOrderStatus', {
              order_id: self.order.order_id,
              status: status
            })
          }
        }
      })
    },
    cancelOrder () {
      let self = this

      this['order/cancel']({
        order_id: self.order.order_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Orden cancelada')
            self.getOrder(self.order.order_id)
            // self.$store.commit('order/updateOrderStatus', {
            //   order_id: self.order.order_id,
            //   status: self.order_status.find(s => s.name == 'refunded')
            // })
          }
        }
      })
    },
    getLocation (pickup_location_id) {
      let self = this

      this['location/get']({
        pickup_location_id: pickup_location_id,
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.pickup_location = res.resource
          }
        }
      })
    },
    getOrderStatusBadge (status) {
      if (status) {
        let s = this.order_status.find(s => s.name == status)
        if (s) {
          return s
        }
      }

      return {
        color: 'secondary',
        title: status,
        description: 'No hay información del estado de la orden.'
      }
    },
    selectAll (value) {
      if (value == true) {
        this.selected_orders = this.parsed_orders.map(o => o.order_id)
      } else {
        this.selected_orders = []
      }
    },
    openOrderModal (order) {
      this.clearObject(this.order)

      this.getOrder(typeof order == 'object' ? order.order_id : order)
    },
    clearOrderModal (open) {
      if (!open) {
        this.clearObject(this.order)
        this.clearObject(this.pickup_location)
      }
    },
    startTimer () {
      let self = this
      self.count_down = 9
      this.refresh_timer = setInterval(() => {
        if(self.count_down > 0) self.count_down--
      }, 1000)
    },
    copy (number) {
      let self = this

      var dummy = document.createElement("textarea")
      document.body.appendChild(dummy)
      dummy.value = number
      dummy.select()
      dummy.setSelectionRange(0, 99999); // for mobile devices
      document.execCommand("copy")
      document.body.removeChild(dummy)
    },
    async confirmPaymentAgaintsDelivery () {
      let message = '¿Deseas poner la orden como Pago contra entrega? No puedes poner la orden nuevamente en proceso.'
      try {
        let response = await this.$bvModal.msgBoxConfirm(message, {
          title: 'Cambiar estado',
          okVariant: 'primary',
          okTitle: 'Cambiar estado',
          cancelTitle: 'Cancelar'
        })

        if (response) {
          this.updateOrder(this.order_status.find(s => s.name == 'pay_on_delivery'))
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    getDeliveryPickupType (item) {
      if (item.delivery_type) {
        return item.delivery_type == 'kanguro' ? 'Envío Kanguro' : 'Envío costo fijo'
      } else if (item.pickup_location_id) {
        return 'Recolección en tienda'
      } else {
        return 'No especificado'
      }
    }
  },
  mounted () {
    this.getPlatforms()
    this.getOrders()

    if (this.$route.query.order_id && !isNaN(this.$route.query.order_id)) {
      this.openOrderModal(this.$route.query.order_id)
    }
  },
  watch: {
    selected_platform () {
      this.resetPaginationData()
      clearTimeout(this.time_out)
      clearInterval(this.refresh_timer)
      this.getOrders()
    },
    selectedTab () {
      this.resetPaginationData()
      clearTimeout(this.time_out)
      clearInterval(this.refresh_timer)
      this.getOrders()
    },
    search (value) {
      if (value.length) {
        this.shouldRefresh = false
      } else {
        this.shouldRefresh = true
      }

      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.resetPaginationData()
        clearTimeout(this.time_out)
        clearInterval(this.refresh_timer)
        this.getOrders()
      }, 700)
    },
    order_modal (value) {
      if (value === false) {
        this.$router.push({query: { order_id: 'false' } }).catch(()=>{});
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.time_out)
    clearInterval(this.refresh_timer)
    this.shouldRefresh = false
  }
}
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
  .scratch {
    text-decoration: line-through;
  }
  .order-status-dropdown {
    width: 330px !important;
    max-width: 330px !important;
  }
</style>
